export const navTree = {
  main: [
    { slug: '/', title: 'Home' },
    { slug: '/angebot', title: 'Angebot' },
    { slug: '/fahrzeuge', title: 'Fahrzeuge' },
    { slug: '/kontakt', title: 'Kontakt' },
  ],
  footer: [{ slug: '/impressum', title: 'Impressum' }],
};
